import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail, ShieldCheck } from "lucide-react";
import { CONTACT, STUDIOS } from "../data/site";
import { Reveal } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="site-footer" className="bg-pine text-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-wood font-semibold mb-6">{t("footer.nextStay")}</p>
          <Link to="/contact" data-testid="footer-cta" className="group block">
            <h2 className="font-serif text-5xl md:text-7xl tracking-tighter leading-[1.05] max-w-3xl">
              {t("footer.title1")}
              <span className="italic text-wood">{t("footer.title2a")}</span>
              <ArrowUpRight aria-hidden className="inline-block ml-4 w-10 h-10 md:w-14 md:h-14 align-baseline transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2" />
            </h2>
          </Link>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-12 mt-20 pt-12 border-t border-cream/10">
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-cream/50 mb-4">{t("footer.contact")}</p>
            <a data-testid="footer-phone" href={CONTACT.phoneHref} className="flex items-center gap-3 text-lg hover:text-wood transition-colors py-1">
              <Phone aria-hidden className="w-4 h-4 text-wood" /> {CONTACT.phone}
            </a>
            <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-lg hover:text-wood transition-colors py-1">
              <Mail aria-hidden className="w-4 h-4 text-wood" /> {CONTACT.email}
            </a>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-cream/50 mb-4">{t("footer.ourStudios")}</p>
            {STUDIOS.map((s) => (
              <Link key={s.slug} data-testid={`footer-link-${s.slug}`} to={`/studio/${s.slug}`} className="block text-lg hover:text-wood transition-colors py-1">
                {s.name}
              </Link>
            ))}
            <Link data-testid="footer-link-contact" to="/contact" className="block text-lg hover:text-wood transition-colors py-1">
              {t("footer.contactLink")}
            </Link>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-cream/50 mb-4">{t("footer.info")}</p>
            <Link data-testid="footer-link-legal" to="/mentions-legales" className="block text-lg hover:text-wood transition-colors py-1">
              {t("footer.legal")}
            </Link>
            <Link data-testid="footer-link-privacy-policy" to="/politique-de-confidentialite" className="block text-lg hover:text-wood transition-colors py-1">
              {t("footer.privacyPolicy")}
            </Link>
            <a data-testid="footer-privacy" href={`mailto:${CONTACT.privacy}`} className="flex items-center gap-3 text-lg hover:text-wood transition-colors py-1">
              <ShieldCheck aria-hidden className="w-4 h-4 text-wood" /> RGPD : {CONTACT.privacy}
            </a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-4 text-sm text-cream/40">
          <p>© 2026 {CONTACT.fullName} — SIREN {CONTACT.siren} — {CONTACT.resort}</p>
          <p>{CONTACT.address}</p>
        </div>
      </div>
    </footer>
  );
};
